import { functions } from "./firebase";
import { httpsCallable } from "firebase/functions";

export const saveEntry = httpsCallable(functions, "saveEntry_V2");
